import * as React from 'react';

export const FilterClear = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M9.613 8.21l.094.083L12 10.585l2.293-2.292a1 1 0 0 1 1.497 1.32l-.083.094L13.415 12l2.292 2.293a1 1 0 0 1-1.32 1.497l-.094-.083L12 13.415l-2.293 2.292a1 1 0 0 1-1.497-1.32l.083-.094L10.585 12 8.293 9.707a1 1 0 0 1 1.32-1.497zm2.28-6.81c.218 0 .371.102.46.304.076.183.06.343-.048.48l-.061.066-3.846 3.846V7.25a1.85 1.85 0 0 0-.82 2.933l.114.125.705.706v.87a.458.458 0 0 1-.223.42l-.08.041a.543.543 0 0 1-.195.04.466.466 0 0 1-.293-.096l-.059-.053-1.997-1.997a.486.486 0 0 1-.138-.253l-.01-.098V6.096L1.556 2.25c-.161-.15-.197-.333-.11-.546a.461.461 0 0 1 .372-.298l.09-.006h9.984z"
    />
  </svg>
);
